var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.8423C8 15.3923 8.45 15.8423 9 15.8423C9.55 15.8423 10 15.3923 10 14.8423C10 14.2923 9.55 13.8423 9 13.8423C8.45 13.8423 8 14.2923 8 14.8423ZM8 0.842285V4.84229H10V2.92229C13.39 3.41229 16 6.31229 16 9.84229C16 13.7123 12.87 16.8423 9 16.8423C5.13 16.8423 2 13.7123 2 9.84229C2 8.16229 2.59 6.62228 3.58 5.42229L9 10.8423L10.41 9.43229L3.61 2.63229V2.65229C1.42 4.29228 0 6.89229 0 9.84229C0 14.8123 4.02 18.8423 9 18.8423C13.97 18.8423 18 14.8123 18 9.84229C18 4.87229 13.97 0.842285 9 0.842285H8ZM15 9.84229C15 9.29228 14.55 8.84229 14 8.84229C13.45 8.84229 13 9.29228 13 9.84229C13 10.3923 13.45 10.8423 14 10.8423C14.55 10.8423 15 10.3923 15 9.84229ZM3 9.84229C3 10.3923 3.45 10.8423 4 10.8423C4.55 10.8423 5 10.3923 5 9.84229C5 9.29228 4.55 8.84229 4 8.84229C3.45 8.84229 3 9.29228 3 9.84229Z",
    fill: "#7C90B1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.ebe187ed.svg";
export { ForwardRef as ReactComponent };